<app-page-bar></app-page-bar>

<app-page>

  <div class="header" *ngIf="invoice">
      <div class="header-main">
        <h2>{{ invoice.client.name }}
            <span *ngIf="invoice.client.client_type === ClientType.Company" class="client-type-badge company">Company</span>
            <span *ngIf="invoice.client.client_type === ClientType.LightEntrepreneur" class="client-type-badge light-entrepreneur">Light Entrepreneur</span>
            <ng-container *ngIf="invoice.number">
                / {{ invoice.number }}
            </ng-container>
            <ng-container *ngIf="invoice.new_number">
                / {{ invoice.new_number }}
            </ng-container>
        </h2>
        <p class="small">Source: <app-source-name [sourceId]="invoice.source_id"></app-source-name><span *ngIf="invoice.correlation_id"> / {{ invoice.correlation_id }}</span></p>
        <label class="legacy-toggle">
          <input
            type="checkbox"
            [checked]="legacyWidgetsVisible$ | async"
            (change)="setLegacyWidgetsVisible($any($event.target).checked)">
          Show legacy widgets
        </label>
        <!-- Invoice Activity and Invoice Documents are console-svelte pages
             (strangler): plain anchors, never routerLink, so the click is a
             document request the BFF can route to the Svelte bundle. -->
        <a class="sub-page-link activity-link" href="/invoices/{{ invoice.id }}/activity">Activity</a>
        <a *ngIf="canPreviewDocuments$ | async" class="sub-page-link documents-link" href="/invoices/{{ invoice.id }}/documents">Documents</a>
      </div>
      <app-invoice-presence-roster-widget class="header-aside"></app-invoice-presence-roster-widget>
    </div>

  <div class="invoice-grid">
      <div class="widget-column full-width-widget">
        <app-invoice-notifications></app-invoice-notifications>
      </div>

      <div class="widget-column full-width-widget">
        <app-invoice-state-widget></app-invoice-state-widget>
      </div>

      <div class="widget-column full-width-widget">
        <app-invoice-financing-holds-widget></app-invoice-financing-holds-widget>
      </div>

      <div class="widget-column">
        <ng-container [ngSwitch]="invoice?.client?.client_type">
          <app-invoice-client-widget *ngSwitchCase="ClientType.Company"></app-invoice-client-widget>
          <app-invoice-le-client-widget *ngSwitchCase="ClientType.LightEntrepreneur"></app-invoice-le-client-widget>
        </ng-container>
        <app-invoice-info-widget *appShowLegacy></app-invoice-info-widget>
        <app-invoice-info-v2-widget></app-invoice-info-v2-widget>
        <app-invoice-financing-widget *appShowLegacy></app-invoice-financing-widget>
        <app-invoice-financing-v2-widget></app-invoice-financing-v2-widget>
        <app-invoice-outgoing-payment-widget></app-invoice-outgoing-payment-widget>
        <app-invoice-attachments-widget *appShowLegacy></app-invoice-attachments-widget>
        <app-invoice-attachments-v2-widget></app-invoice-attachments-v2-widget>
        <ng-container [ngSwitch]="invoice?.client?.client_type">
          <app-invoice-client-invoices-widget *ngSwitchCase="ClientType.Company"></app-invoice-client-invoices-widget>
          <app-invoice-le-client-invoices-widget *ngSwitchCase="ClientType.LightEntrepreneur"></app-invoice-le-client-invoices-widget>
        </ng-container>
        <app-invoice-pcr-widget></app-invoice-pcr-widget>
      </div>

      <div class="widget-column">
        <app-invoice-end-customer-widget></app-invoice-end-customer-widget>
        <app-invoice-comments-v2-widget></app-invoice-comments-v2-widget>
        <app-invoice-end-customer-invoices-widget></app-invoice-end-customer-invoices-widget>
        <app-invoice-payment-history-widget></app-invoice-payment-history-widget>
        <app-invoice-end-customer-credit-insurance-widget></app-invoice-end-customer-credit-insurance-widget>
        <app-invoice-notifications-widget></app-invoice-notifications-widget>
        <app-invoice-email-widget *appShowLegacy></app-invoice-email-widget>
        <app-invoice-email-v2-widget></app-invoice-email-v2-widget>
        <app-invoice-sms-widget></app-invoice-sms-widget>
      </div>
    </div>

</app-page>

<app-invoice-ai-chat-widget></app-invoice-ai-chat-widget>
